// extracted by mini-css-extract-plugin
module.exports = {"iframe":"az_bgb"};